import React from "react";
import { Grid, Paper, Typography, Stack } from "@mui/material";
import {
  LocalShipping,
  CheckCircle,
  Cancel,
  DirectionsCar,
} from "@mui/icons-material";

const DaySummaryCards = ({ day }) => {
  return (
    <Grid container spacing={2} mb={3}>
      <Grid item xs={6} sm={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#e3f2fd" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            mb={1}
          >
            <LocalShipping sx={{ color: "#1976d2" }} />
            <Typography variant="caption" color="primary" fontWeight="medium">
              Total Orders
            </Typography>
          </Stack>
          <Typography variant="h4" fontWeight="bold" color="primary">
            {day.totalOrders}
          </Typography>
        </Paper>
      </Grid>

      <Grid item xs={6} sm={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#e8f5e8" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            mb={1}
          >
            <CheckCircle sx={{ color: "#2e7d32" }} />
            <Typography
              variant="caption"
              color="success.main"
              fontWeight="medium"
            >
              Delivered
            </Typography>
          </Stack>
          <Typography variant="h4" fontWeight="bold" color="success.main">
            {day.deliveredOrders}
          </Typography>
        </Paper>
      </Grid>

      {day.failedOrders > 0 && (
        <Grid item xs={6} sm={3}>
          <Paper
            variant="outlined"
            sx={{ p: 2, textAlign: "center", bgcolor: "#ffebee" }}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="center"
              spacing={1}
              mb={1}
            >
              <Cancel sx={{ color: "#c62828" }} />
              <Typography
                variant="caption"
                color="error.main"
                fontWeight="medium"
              >
                Failed
              </Typography>
            </Stack>
            <Typography variant="h4" fontWeight="bold" color="error.main">
              {day.failedOrders}
            </Typography>
          </Paper>
        </Grid>
      )}

      <Grid item xs={6} sm={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#f3e5f5" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            mb={1}
          >
            <DirectionsCar sx={{ color: "#bb5502" }} />
            <Typography
              variant="caption"
              fontWeight="medium"
              sx={{ color: "#ef6c00" }}
            >
              Stops
            </Typography>
          </Stack>
          <Typography variant="h4" fontWeight="bold" sx={{ color: "#ef6c00" }}>
            {day.totalStops}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6} sm={3}>
        <Paper
          variant="outlined"
          sx={{ p: 2, textAlign: "center", bgcolor: "#f3e5f5" }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
            mb={1}
          >
            <CheckCircle />
            <Typography variant="caption" fontWeight="medium">
              Total Hours
            </Typography>
          </Stack>
          <Typography variant="h4" fontWeight="bold" color="secondary.main">
            {day.hoursWorked}
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default DaySummaryCards;
